"use strict";

var _regeneratorRuntime = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultCacheResponseForSeconds = 2 * 60;
var defaultMaxSize = 100;

var RequestWithCache = /*#__PURE__*/function () {
  function RequestWithCache() {
    _classCallCheck(this, RequestWithCache);

    this.responseCache = new Map();
  } // Todo: should probably be passed a callback instead, or an apiCall instance. Types are messy this way


  _createClass(RequestWithCache, [{
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestContext, requestFunction, requestFunctionArguments, cacheOptions) {
        var _cacheOptions$cacheRe, cacheResponseForSeconds, _cacheOptions$maxSize, maxSize, isCacheDisabled, requestFunctionArgumentsJSON, cacheEntry, now, isEntryValid, response, isCacheOverMaxSize, oldestEntry;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _cacheOptions$cacheRe = cacheOptions.cacheResponseForSeconds, cacheResponseForSeconds = _cacheOptions$cacheRe === void 0 ? defaultCacheResponseForSeconds : _cacheOptions$cacheRe, _cacheOptions$maxSize = cacheOptions.maxSize, maxSize = _cacheOptions$maxSize === void 0 ? defaultMaxSize : _cacheOptions$maxSize;
                isCacheDisabled = cacheResponseForSeconds <= 0 || maxSize <= 0;

                if (!isCacheDisabled) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", requestFunction.call.apply(requestFunction, [requestContext].concat(_toConsumableArray(requestFunctionArguments))));

              case 4:
                requestFunctionArgumentsJSON = JSON.stringify(requestFunctionArguments);
                cacheEntry = this.responseCache.get(requestFunctionArgumentsJSON);
                now = Date.now();

                if (!cacheEntry) {
                  _context.next = 16;
                  break;
                }

                isEntryValid = now - cacheEntry.requestTimestamp < cacheResponseForSeconds * 1000;

                if (!isEntryValid) {
                  _context.next = 15;
                  break;
                }

                this.responseCache.delete(requestFunctionArgumentsJSON);
                this.responseCache.set(requestFunctionArgumentsJSON, cacheEntry);
                return _context.abrupt("return", Promise.resolve(cacheEntry.response));

              case 15:
                this.responseCache.delete(requestFunctionArgumentsJSON);

              case 16:
                _context.next = 18;
                return requestFunction.call.apply(requestFunction, [requestContext].concat(_toConsumableArray(requestFunctionArguments)));

              case 18:
                response = _context.sent;
                this.responseCache.set(requestFunctionArgumentsJSON, {
                  requestTimestamp: now,
                  response: response
                });
                isCacheOverMaxSize = this.responseCache.size > maxSize;

                if (isCacheOverMaxSize) {
                  oldestEntry = this.responseCache.keys().next().value;
                  this.responseCache.delete(oldestEntry);
                }

                return _context.abrupt("return", response);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function perform(_x, _x2, _x3, _x4) {
        return _perform.apply(this, arguments);
      }

      return perform;
    }()
  }]);

  return RequestWithCache;
}();

exports.default = RequestWithCache;